import { useMutation } from "@tanstack/react-query";
import { useWebRouter } from "~utils/next-router/use-web-router";
import { UpdatePasswordFormValues } from "ui-components";
import { apiInstance } from "utils";

export type UpdatePasswordBody = Record<string, unknown>;
export type UpdatePasswordResponse = Record<string, unknown>;

export const useUpdatePassword = () => {
	const {
		_query: { userId, token },
	} = useWebRouter();

	return useMutation({
		mutationKey: ["updatePassword"],
		mutationFn: async (values: UpdatePasswordFormValues) => {
			const postForm = new FormData();
			postForm.append("_method", "put");
			postForm.append("user[password]", values.password);
			postForm.append("user[password_confirmation]", values.retypedPassword);
			return apiInstance.post(
				`/users/${userId}/password?token=${token}`,
				postForm,
			);
		},
	});
};
